export default __webpack_public_path__ + "static/media/4.5525bb13.png";